import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import { Card, Grid } from "@mui/material";
import { Box, styled } from "@mui/system";
import {
    InputPassword,
    InputText,
    Paragraph,
    setTitleCase,
} from "app/components/template/partials";
import { Field, Formik } from "formik";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { RegexUsername } from "../../../../configs/regex";

// HOOKS
import useAuth from "../../../hooks/useAuth";

const FlexBox = styled(Box)(() => ({ display: "flex", alignItems: "center" }));

const JustifyBox = styled(FlexBox)(() => ({ justifyContent: "center" }));

const ContentBox = styled(JustifyBox)(() => ({
    height: "100%",
    padding: "32px",
    background: "rgba(0, 0, 0, 0.01)",
}));

// inital login credentials
const initialValues = {
    fullname: "",
    username: "",
    email_nohp: "",
    password: "",
    role: "warga",
    description: "USER",
};

// form field validation schema
const validationSchema = Yup.object().shape({
    fullname: Yup.string().required("Nama Lengkap wajib diisi!"),
    username: Yup.string()
        .required("Nama Pengguna wajib diisi!")
        .matches(
            RegexUsername,
            "Format Nama Pengguna tidak sesuai, minimal 6 digit dan hanya menggunakan huruf dan angka"
        ),
    password: Yup.string().required("Kata Sandi wajib diisi!"),
    confirm_password: Yup.string()
        .required("Konfirmasi Kata Sandi wajib diisi!")
        .oneOf(
            [Yup.ref("password"), null],
            "Konfirmasi Kata Sandi tidak sama dengan Kata Sandi"
        ),
});

export function SignUpPage() {
    const navigate = useNavigate();
    const theme = useTheme();
    const [isLoading, setLoading] = useState(false);

    const { signUp } = useAuth();

    const handleFormSubmit = async (values) => {
        setLoading(true);
        try {
            await signUp(values);
            toast.success(
                setTitleCase("berhasil membuat akun. silakan login!")
            );
            navigate("/");
        } catch (error) {
            toast.error(setTitleCase(error.response.data?.message));
        }
        setLoading(false);
    };

    return (
        <Card className="auth-content-card-border">
            <Grid container>
                <Grid item sm={6} xs={12}>
                    <ContentBox>
                        <img
                            src="/assets/images/bg-form-auth.webp"
                            width="100%"
                            height="100%"
                            alt="sign-up images"
                            loading="lazy"
                        />
                    </ContentBox>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Box p={4} height="100%">
                        <Formik
                            enableReinitialize
                            onSubmit={handleFormSubmit}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                        >
                            {({ handleSubmit }) => (
                                <form onSubmit={handleSubmit}>
                                    <Field
                                        component={InputText}
                                        name="fullname"
                                        label="Nama Lengkap"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                    <Field
                                        component={InputText}
                                        name="username"
                                        label="Nama Pengguna"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                    <Field
                                        component={InputPassword}
                                        name="password"
                                        label="Kata Sandi"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                    <Field
                                        component={InputPassword}
                                        name="confirm_password"
                                        label="Konfirmasi Kata Sandi"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />
                                    <Field
                                        component={InputText}
                                        name="email_nohp"
                                        label="Nomor HP"
                                        size="small"
                                        variant="outlined"
                                        type="email_nohp"
                                        fullWidth
                                        sx={{ mb: 2 }}
                                    />

                                    {/* <FlexBox gap={1} alignItems="center">
                      <Checkbox
                        size="small"
                        name="remember"
                        onChange={handleChange}
                        checked={values.remember}
                        sx={{ padding: 0 }}
                      />

                      <Paragraph fontSize={13}>
                        I have read and agree to the terms of service.
                      </Paragraph>
                    </FlexBox> */}

                                    <LoadingButton
                                        type="submit"
                                        color="primary"
                                        loading={isLoading}
                                        variant="contained"
                                        sx={{ mb: 2, mt: 3 }}
                                    >
                                        Daftar
                                    </LoadingButton>

                                    <Paragraph>
                                        Sudah ada akun?
                                        <NavLink
                                            to="/auth/sign-in"
                                            style={{
                                                color: theme.palette.primary
                                                    .main,
                                                marginLeft: 5,
                                            }}
                                        >
                                            Halaman Masuk
                                        </NavLink>
                                    </Paragraph>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );
}
